import { memo } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ChatProvider } from './contexts/ChatContext';
import Auth0ProviderWithNavigate from './components/auth/Auth0ProviderWithNavigate';
import ErrorBoundary from './components/ErrorBoundary';
import AppRoutes from './AppRoutes';

// Styles
import 'bootstrap/dist/css/bootstrap.min.css';
import '../scss/custom.scss';
import { ModalProvider } from './contexts/ModalContext';
import { AuthProvider } from './contexts/AuthContext';

const App = memo(() => {
    return (
        <ErrorBoundary>
            <Router>
                <Auth0ProviderWithNavigate>
                    <AuthProvider>
                        <ChatProvider>
                            <ModalProvider>
                                <AppRoutes />
                            </ModalProvider>
                        </ChatProvider>
                    </AuthProvider>
                </Auth0ProviderWithNavigate>
            </Router>
        </ErrorBoundary>
    );
});

App.displayName = 'App';

export default App;